import { render, staticRenderFns } from "./DetailReportCaseStudy.vue?vue&type=template&id=2c61ae02&scoped=true"
import script from "./DetailReportCaseStudy.vue?vue&type=script&lang=js"
export * from "./DetailReportCaseStudy.vue?vue&type=script&lang=js"
import style0 from "./DetailReportCaseStudy.vue?vue&type=style&index=0&id=2c61ae02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c61ae02",
  null
  
)

export default component.exports